import React from 'react';
import Responsive from '@amzn/meridian/responsive';
import { responsiveProps } from 'src/constants/responsiveProps';
import Icon from '@amzn/meridian/icon';
import chevronLeftSmallTokens from '@amzn/meridian-tokens/base/icon/chevron-left-small';
import arrowsUpAndDownTokens from '@amzn/meridian-tokens/base/icon/arrows-up-and-down';
import Button from '@amzn/meridian/button';
import Row from '@amzn/meridian/row';
import Breadcrumb, { BreadcrumbGroup } from '@amzn/meridian/breadcrumb';
import BarcodeScan from 'src/components/common/barcode-scan/BarcodeScan';
import { isEmpty, isNotEmpty } from 'src/utils/object-utils';
import { ContainerDetailsModel } from 'src/components/common/container-details/ContainerDetailsModel';
import {
    buildGetContainerDetailsInput,
    GetContainerDetailsInput,
    GetContainerMode
} from 'src/models/GetContainerDetails';
import { ScanIcons } from 'src/constants/general-media';
import { SortContainerPages } from 'src/store/common-slices/sortContainerSlice';
import { UIAlertState } from 'src/store/common-slices/uiSlice';
import * as AppStrings from 'src/localization/string-ids/app-strings';
import * as AppRoutes from 'src/routing/constants/routes';
import '../Sortation.scss';

interface ScanSourceForSortStateProps {
    containerDetails?: ContainerDetailsModel;
    childContainers: ContainerDetailsModel[];
    warehouseId: string,
    associate: string,
    locale: string,
    selectedSortType: string
}

interface ScanSourceForSortDispatchProps {
    setPageToRender: (pageToRender: SortContainerPages) => void;
    fetchContainerDetails: (getContainerDetailsInput: GetContainerDetailsInput) => void;
    updateChildContainers: (newContainer: ContainerDetailsModel) => void;
}

type Props = ScanSourceForSortStateProps & ScanSourceForSortDispatchProps;

class ScanSourceForSort extends React.Component<Props, any> {

    private onSubmit = async (containerId: string) => {
        await this.props.fetchContainerDetails(buildGetContainerDetailsInput(containerId,
            this.props.warehouseId, this.props.associate, this.props.locale,
            GetContainerMode.SORT, true));
        if (this.props.containerDetails) {
            await this.props.updateChildContainers(this.props.containerDetails);
            this.props.setPageToRender(SortContainerPages.SCAN_DESTINATION_CONTAINER_PAGE)
        }
    }

    public render() {
        return(
            <Responsive query={"max-width"} props={responsiveProps}>
                {props => (
                    <>
                        <div className={"sortation sortation-source-scan-container"}>
                            <BreadcrumbGroup>
                                <Breadcrumb href={AppRoutes.HOME_PAGE_ROUTE}>{AppStrings.HOME}</Breadcrumb>
                                <Breadcrumb href={AppRoutes.SUB_SORT_PAGE_ROUTE}>{AppStrings.SORT}</Breadcrumb>
                                <Breadcrumb>{this.props.selectedSortType}</Breadcrumb>
                            </BreadcrumbGroup>

                            <Row>
                                <Button
                                    type={"secondary"}
                                    onClick={() => this.props.setPageToRender(SortContainerPages.SELECT_SORT_TYPE_PAGE)}
                                    circular={true}
                                    data-testid="sort-source-back-button"
                                >
                                    <Icon tokens={chevronLeftSmallTokens} />
                                </Button>
                            </Row>
                        </div>

                        <BarcodeScan
                            shouldRenderImageOrIcon={isEmpty(this.props.childContainers)}
                            scanImageOrIcon={ScanIcons.SCAN_HANDHELD_ICON}
                            scanImageAltText="Scan Handheld Icon"
                            shouldRenderText={!props.isScanner}
                            scanText={AppStrings.SORTATION_SCAN_SOURCE_CONTAINER_TEXT}
                            inputLabel={AppStrings.SORTATION_SCAN_SOURCE_CONTAINER_INPUT_LABEL}
                            inputPlaceholder={AppStrings.SORTATION_SCAN_SOURCE_CONTAINER_PLACEHOLDER}
                            shouldRenderButton={true}
                            buttonText={AppStrings.SORTATION_SCAN_SOURCE_CONTAINER_BUTTON}
                            buttonIcon={<Icon tokens={arrowsUpAndDownTokens} />}
                            onSubmit={this.onSubmit}
                            headingTestId="sort-source-heading"
                            inputTestId="sort-source-input"
                            buttonTestId="sort-source-submit-button"
                        />

                    </>
                )}
            </Responsive>
        );
    }
}

export default ScanSourceForSort;